import {
    IonBadge, IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader,
    IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonNote, IonPage, IonRow,
    IonSearchbar, IonTitle, IonToolbar, useIonViewDidEnter, IonFabButton, IonFab, IonItem, IonLabel, IonCheckbox, IonInput
} from "@ionic/react";
import { cart, cartOutline, chevronBackOutline, searchOutline, bagCheck } from "ionicons/icons";
import { useEffect, useRef, useState, useContext } from "react";
import { useParams } from "react-router"
import { useHistory } from "react-router-dom";

import AuthContext from '../UserContext';
import ProductCard from "../components/ProductCard";

import { CartStore } from "../data/CartStore";
import { ProductStore } from "../data/ProductStore";
import { CategoryStore } from "../data/CategoryStore";
import { Preferences } from "@capacitor/preferences";

import { fetchMoreProducts } from "../data/fetcher";

import styles from "./CategoryProducts.module.css";

const CategoryProducts = () => {

    const history = useHistory();
    const { authValues } = useContext(AuthContext);
    const params = useParams();
    const cartRef = useRef();
    const products = ProductStore.useState(s => s.products);
    const shopCart = CartStore.useState(s => s.product_ids);
    const [inventoryCategory, setInventoryCategory] = useState({});
    const categories = CategoryStore.useState(s => s.categories);
    const [category, setCategory] = useState({});
    const [searchResults, setsearchResults] = useState([]);
    const [amountLoaded, setAmountLoaded] = useState(11);
    const [searchVal, setSearchVal] = useState("");
    const [totalProducts, setTotalProducts] = useState(0);

    useEffect(() => {

        if (categories.length < 1)
            return;
        
        const categorySlug = params.slug;
        const tempCategory = categories.filter(c => c.name === categorySlug)[0];
        
        if (!tempCategory)
            return;
        
        setCategory(tempCategory);
    }, [categories]);

    useEffect(() => {

        if (products.length < 1)
            return;

        const categorySlug = params.slug;

        //const categorySlug = window.location.pathname.split("/").pop();
        const tempInventoryCategory = products.filter(p => p.slug === categorySlug)[0];

        if (!tempInventoryCategory)
            return;

        setInventoryCategory(tempInventoryCategory);
        setsearchResults(tempInventoryCategory.products);
        setTotalProducts(tempInventoryCategory.totalProducts);
    }, [products]);

    const fetchMore = async (e) => {

        // Increment the amount loaded by 6 for the next iteration
        setAmountLoaded(prevAmount => {
            const newAmount = prevAmount + 6;

            // Save state immediately after updating amountLoaded
            const stateToSave = {
                amountLoaded: newAmount,
                searchResults,
                timestamp: Date.now() // Add a timestamp to enable cleanup of old sessions
            };

            const saveKey = `session_categoryFetchState-${params.slug}`;
            Preferences.set({
                key: saveKey,
                value: JSON.stringify(stateToSave)
            });

            return newAmount;
        });
        e.target.complete();
    }

    // Fetch more products, if amountLoaded exceeds what is available in the frontend
    useEffect(() => {
        if (amountLoaded > searchResults.length && amountLoaded < totalProducts) {
            const currentPage = ProductStore.getRawState().products.find(cat => cat.slug === inventoryCategory.slug)?.currentPage || 1;
        
            // Fetch more products
            fetchMoreProducts(inventoryCategory.slug, currentPage);
        }
    }, [amountLoaded]);

    const search = async e => {

        setSearchVal(e.target.value);

        if (searchVal !== "") {

            const tempResults = inventoryCategory.products.filter(p => p.name.toLowerCase().includes(searchVal.toLowerCase()));
            setsearchResults(tempResults);
        } else {

            setsearchResults(inventoryCategory.products);
        }

        Preferences.remove({ key: `session_categoryFetchState-${params.slug}` });
    }

    // Restore state when entering the view
    useIonViewDidEnter(() => {
        const restoreFetchState = async () => {
            // Create the same key based on the current search parameters
            const key = `session_categoryFetchState-${params.slug}`;

            const { value } = await Preferences.get({ key });

            if (value) {
                try {
                    const savedState = JSON.parse(value);

                    // Check if the saved state is from the current session (within last 24 hours)
                    const isCurrentSession = savedState.timestamp &&
                        (Date.now() - savedState.timestamp < 24 * 60 * 60 * 1000);

                    if (isCurrentSession) {
                        if (savedState.searchResults && savedState.searchResults.length > 0) {
                            setsearchResults(savedState.searchResults);
                        }

                        if (savedState.amountLoaded) {
                            setAmountLoaded(savedState.amountLoaded);
                        }
                    } else {
                        // Clean up expired session data
                        await Preferences.remove({ key });
                    }
                } catch (error) {
                    console.error("Error restoring fetch state:", error);
                }
            }
        };

        restoreFetchState();
     });

    const [attributeFilters, setAttributeFilters] = useState({});

    return (

        <IonPage id="category-page" className={styles.categoryPage}>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="dark" text={inventoryCategory.name} routerLink="/categories" routerDirection="back">
                            <IonIcon color="dark" icon={chevronBackOutline} />&nbsp;Categories
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{inventoryCategory && inventoryCategory.name}</IonTitle>

                    <IonButtons slot="end">
                        <IonBadge color="dark">
                            {shopCart.length}
                        </IonBadge>
                        <IonButton color="dark" routerLink="/cart">
                            <IonIcon ref={cartRef} className="animate__animated" icon={cart} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>

            </IonHeader>

            <IonContent fullscreen className={`page-content`}>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="dark" text={inventoryCategory.name} routerLink="/categories" routerDirection="back">
                            <IonIcon color="dark" icon={chevronBackOutline} />&nbsp;Back
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{inventoryCategory && inventoryCategory.name}</IonTitle>

                    <IonButtons slot="end" class="ion-padding-left">
                        <IonButton color="drukre" routerLink="/cart">
                            {shopCart.length}
                            <IonIcon ref={cartRef} className="animate__animated" icon={cartOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>

                <IonSearchbar className={styles.search} value={searchVal} onKeyUp={search} placeholder="Search this category" searchIcon={searchOutline} animated={true} />
                {/*attributes */}
                {category && category.attributes && (
                    <IonRow className={styles.attributesToolbar}>
                        {Object.keys(category.attributes).map((attr, index) => (
                            ('boolean' === category.attributes[attr]) ? (
                                <IonCol key={index} sizeMd="2" sizeSm="3" sizeXs="6">
                                    <IonItem lines="none">
                                        <IonLabel>{attr.toUpperCase().replace('_', ' ')}</IonLabel>
                                        <IonCheckbox slot="start" onIonChange={(e) => {
                                            const checked = e.detail.checked;
                                            setAttributeFilters(prevFilters => {
                                                const newFilters = { ...prevFilters, [attr]: checked };

                                                // Filter products based on the updated attribute filters
                                                let filteredProducts = inventoryCategory.products;

                                                Object.keys(newFilters).forEach(filterKey => {
                                                    if (newFilters[filterKey]) {
                                                        filteredProducts = filteredProducts.filter(p => p.data && p.data[filterKey]);
                                                    }
                                                });

                                                setsearchResults(filteredProducts);
                                                return newFilters;
                                            });
                                        }}/>
                                    </IonItem>
                                </IonCol>
                            ) : (
                                <IonCol key={index} sizeMd="2" sizeSm="3" sizeXs="6">
                                    <IonInput labelPlacement="floating" fill="outline"
                                        label={attr.toUpperCase().replace('_', ' ')} 
                                        onIonInput={(e) => {
                                            const value = e.target.value;
                                            setAttributeFilters(prevFilters => {
                                                const newFilters = { ...prevFilters, [attr]: value };

                                                // Filter products based on the updated attribute filters
                                                let filteredProducts = inventoryCategory.products;

                                                Object.keys(newFilters).forEach(filterKey => {
                                                    if (newFilters[filterKey]) {
                                                        filteredProducts = filteredProducts.filter(p => p.data && p.data[filterKey] && p.data[filterKey].toString().toLowerCase().includes(newFilters[filterKey].toString().toLowerCase()));
                                                    }
                                                });

                                                setsearchResults(filteredProducts);
                                                return newFilters;
                                            });
                                        }}
                                    ></IonInput>
                                </IonCol>
                            )
                        ))}
                    </IonRow>
                )}

                <IonGrid>

                    <IonRow className="ion-text-center">
                        <IonCol size="12">
                            <IonNote>{searchResults && searchResults.length} {(searchResults.length > 1 || searchResults.length === 0) ? " products" : " product"} found. You are searching {inventoryCategory.name}</IonNote>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        {searchResults && searchResults.map((product, index) => {

                            if ((index <= amountLoaded) && product.images) {
                                return (
                                    <IonCol sizeSm="6" sizeMd="3" key={`category_product_${index}`}>
                                        <ProductCard key={`category_product_${index}`} product={product} index={index} cartRef={cartRef} category={inventoryCategory} />
                                    </IonCol>
                                );
                            }
                        })}
                    </IonRow>
                </IonGrid>
                
                <IonFab horizontal="end" vertical="bottom" slot="fixed">
                    <IonFabButton color="drukre" onClick={() => authValues.authenticated ? history.push("/my-products") : history.push("/login")}>
                        <IonIcon icon={bagCheck}></IonIcon><sub>Sell</sub>
                    </IonFabButton>
                </IonFab>

                <IonInfiniteScroll threshold="100px" onIonInfinite={fetchMore}>
                    <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Fetching more...">
                    </IonInfiniteScrollContent>
                </IonInfiniteScroll>
            </IonContent>
        </IonPage>
    );
}

export default CategoryProducts;